import * as angular from 'angular';
import * as Fields from './predefinedContextualFields';
import { ContextualField, PropertyType } from '../../../models';

const groupProperty = {
    modelName: 'group',
    propertyType: PropertyType.Group,
    label: 'Group',
    propertyName: 'groupProperty',
    required: false,
    icon: 'fa-sitemap',
    extraData: {
        groups: []
    }
};
const is2DTableProperty: ContextualField = {
    modelName: 'is2DTable',
    propertyType: PropertyType.Boolean,
    label: '2D table',
    placeholder: '2D table',
    propertyName: 'is2DTableProperty',
    required: false,
    icon: 'fa-th'
};
const isBoundProperty = {
    modelName: 'isBound',
    propertyType: PropertyType.Boolean,
    label: 'Bind',
    placeholder: 'Bind',
    propertyName: 'isBoundProperty',
    required: false,
    icon: 'fa-link'
};

export const spotWidgetsContextualFields : ContextualField[] = [
    is2DTableProperty,
    isBoundProperty,
    groupProperty,
    {
        modelName: 'hasLastValue',
        propertyType: PropertyType.Boolean,
        label: 'Show previous value',
        placeholder: 'Show previous value',
        propertyName: 'hasLastValueProperty',
        required: false,
        iconText: '[',
    },
    angular.copy(Fields.NameConfiguration.HasGroupName),
    {
        modelName: 'hasTimeStamp',
        propertyType: PropertyType.Boolean,
        label: 'TimeStamp',
        placeholder: 'TimeStamp',
        propertyName: 'hasTimeStampProperty',
        required: false,
        icon: 'fa-clock-o',
    },
    angular.copy(Fields.NameConfiguration.HasName),
    angular.copy(Fields.NameConfiguration.HasShortComment),
    {
        modelName: 'hasTagName',
        propertyType: PropertyType.Boolean,
        label: 'Tag name',
        placeholder: 'Tag name',
        propertyName: 'hasTagNameProperty',
        required: false,
        icon: 'fa-tag',
    },
    angular.copy(Fields.NameConfiguration.HasTagShortComment),
    angular.copy(Fields.NameConfiguration.HasUnit),
    {
        modelName: 'hasValue',
        propertyType: PropertyType.Boolean,
        label: 'Value',
        placeholder: 'Value',
        propertyName: 'hasValueProperty',
        required: false,
        icon: 'fa-trophy',
    },
    {
        modelName: 'hasUserComment',
        propertyType: PropertyType.Boolean,
        label: 'User comment',
        placeholder: 'User comment',
        propertyName: 'hasUserCommentProperty',
        required: false,
        icon: 'fa-commenting-o',
    },
    angular.copy(Fields.IsDependentGroupsIncluded),
    angular.copy(Fields.LaunchTask)
];